import { render, staticRenderFns } from "./StatisticsSettingsDatasetFilter.vue?vue&type=template&id=3b6ad552"
import script from "./StatisticsSettingsDatasetFilter.vue?vue&type=script&lang=js"
export * from "./StatisticsSettingsDatasetFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports